var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_16453_120954)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 37,
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 38,
    width: 38,
    height: 38,
    rx: 7,
    stroke: "#4251DA",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9242 46C59.4526 46 59.9626 46.2251 60.3164 46.6122L60.7713 47.1074C60.9781 47.337 61.3319 47.4135 61.6214 47.292L62.2463 47.0309C62.4806 46.9319 62.7333 46.8823 62.9861 46.8823C63.8177 46.8823 64.5575 47.4271 64.7872 48.2059L64.9848 48.8406C65.0721 49.1422 65.3478 49.3538 65.6695 49.3673L66.3495 49.3943C66.8825 49.4168 67.3834 49.6644 67.7234 50.0741C68.0588 50.4837 68.2012 51.0149 68.1139 51.5326L67.9991 52.1899C67.9485 52.5005 68.1002 52.8066 68.385 52.9552L68.9824 53.2703C69.4556 53.5179 69.7957 53.9546 69.9197 54.4678C70.0438 54.981 69.9335 55.5212 69.6257 55.9488L69.2351 56.4936C69.0467 56.7502 69.0513 57.0968 69.2397 57.3489L69.6394 57.8891C69.9565 58.3123 70.0714 58.8525 69.9565 59.3657C69.8416 59.8789 69.5062 60.32 69.0375 60.5766L68.4448 60.9008C68.1645 61.0538 68.0128 61.3644 68.0726 61.6751L68.1966 62.3278C68.2931 62.8455 68.1599 63.3767 67.8291 63.7909C67.4982 64.205 67.002 64.4571 66.4644 64.4886L65.7843 64.5292C65.4627 64.5472 65.187 64.7632 65.1043 65.0649L64.9251 65.7086C64.7045 66.5054 63.9602 67.0591 63.1193 67.0591C62.8758 67.0591 62.6368 67.0096 62.4071 66.9196L61.7776 66.6675C61.4835 66.5504 61.1343 66.6315 60.9276 66.8656L60.4818 67.3698C60.1234 67.7704 59.6088 68 59.0666 68C58.5382 68 58.0282 67.7749 57.6744 67.3878L57.2195 66.8926C57.0127 66.663 56.6589 66.5865 56.3694 66.708L55.7445 66.9691C55.5102 67.0681 55.2575 67.1177 55.0048 67.1177C54.1731 67.1177 53.4333 66.5729 53.2036 65.7941L53.0152 65.1549C52.9279 64.8533 52.6522 64.6417 52.3305 64.6282L51.6505 64.6012C51.1175 64.5787 50.6166 64.3311 50.2766 63.9214C49.9412 63.5118 49.7988 62.9806 49.8861 62.4629L50.0009 61.8056C50.0515 61.495 49.8998 61.1889 49.615 61.0403L49.0176 60.7252C48.5444 60.4776 48.2043 60.0409 48.0803 59.5277C47.9562 59.0145 48.0665 58.4743 48.3743 58.0467L48.7649 57.5019C48.9533 57.2453 48.9487 56.8987 48.7603 56.6466L48.3606 56.1109C48.0435 55.6877 47.9286 55.1475 48.0435 54.6343C48.1584 54.1211 48.4938 53.68 48.9625 53.4234L49.5552 53.0992C49.8355 52.9462 49.9872 52.6356 49.9274 52.3249L49.8034 51.6722C49.7069 51.159 49.8401 50.6233 50.1709 50.2091C50.5018 49.795 51.0026 49.5384 51.5356 49.5114L52.2111 49.4708C52.5327 49.4528 52.8084 49.2368 52.8911 48.9351L53.0703 48.2914C53.2909 47.4946 54.0352 46.9409 54.8761 46.9409C55.1196 46.9409 55.3586 46.9904 55.5883 47.0804L56.2178 47.3325C56.5119 47.4496 56.8611 47.3685 57.0679 47.1344L57.509 46.6302C57.8674 46.2296 58.382 46 58.9242 46ZM62.7939 54.4855L58.0797 58.6646L55.4561 56.3388C55.1719 56.0869 54.7374 56.1131 54.4855 56.3972C54.2337 56.6813 54.2598 57.1159 54.5439 57.3677L58.0797 60.5021L63.7061 55.5145C63.9902 55.2626 64.0163 54.8281 63.7645 54.5439C63.5126 54.2598 63.0781 54.2337 62.7939 54.4855Z",
    fill: "#4251DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_16453_120954",
    x: 0,
    y: 0,
    width: 118,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.172116 0 0 0 0 0.247988 0 0 0 0 0.43767 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16453_120954"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.048514 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_16453_120954",
    result: "effect2_dropShadow_16453_120954"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_16453_120954",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep);
export default __webpack_public_path__ + "static/media/step.d2f4fd17803fb54f9e10d96908d74a72.svg";
export { ForwardRef as ReactComponent };